import Worker from '@advisor/models/store/worker';

export const stateObj = () => new Worker();

export const getters = {
  isJobsAvailable: (state) => state.jobs.length > 0,
};

export const actions = {
  addJobToList({commit}, job) {
    commit('ADD_JOB_TO_LIST', job);
  },
  clearJobs({commit}) {
    commit('CLEAR_JOB_LIST');
  },
  removeJobFromList({commit}, job) {
    commit('REMOVE_JOB_FROM_LIST', job);
  },
};

export const mutations = {
  ADD_JOB_TO_LIST(state, payload) {
    state.jobs.push(payload);
  },
  CLEAR_JOB_LIST(state) {
    state.jobs = [];
  },
  REMOVE_JOB_FROM_LIST(state, job) {
    if (job.payload?.jobId) {
      state.jobs = state.jobs.filter((currentJob) => job.payload.jobId !== currentJob.payload.jobId);
    }
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
